<mat-progress-bar
  [style.visibility]="loading ? 'visible' : 'hidden'"
  mode="indeterminate"
  >
</mat-progress-bar>
<form [formGroup]="form" (submit)="submit(form.value)" auto-animate>
  <ca-form-field>
    <label>Email Address</label>
    <input
      caInput
      onLightBackground="true"
      type="email"
      formControlName="email"
      placeholder="Email Address"
      />
  </ca-form-field>

  <ca-form-field>
    <label>ID (optional)</label>
    <mat-hint>{{ "invite.externalIdDescription" | translate }}</mat-hint>
    <input
      caInput
      onLightBackground="true"
      type="string"
      autocapitalize="off"
      autocomplete="off"
      formControlName="externalId"
      placeholder="ID (optional)"
      />
  </ca-form-field>
  <br />

  <label class="font-semibold text-sm block">Role</label>

  <ca-role-select
    placeholder="Role"
    formControlName="role"
    [options]="roleOptions"
  ></ca-role-select>

  @if (form.get('role').value === CARER) {
    <div
      class="mt-8"
      formGroupName="qualifications"
      >
      <mat-slide-toggle formControlName="accessAllCustomers">{{
        "staff.accessAllCustomers" + form.get("role").value | translate
      }}</mat-slide-toggle>
      @if (
        !!form.get('qualifications').get('accessAllCustomers').value) {
        <p
          >
          {{
          "staff.accessAllCustomersEnabled" + form.get("role").value | translate
          }}
        </p>
      } @else {
        <p>
          {{
          "staff.accessAllCustomersDisabled" + form.get("role").value
          | translate
          }}
        </p>
      }
      @if (
        form.get('role').value === CARER &&
        !form.get('qualifications').get('accessAllCustomers').value
        ) {
        <div
          >
          <div class="row">
            <ca-avatar-stack
              [size]="'small'"
              item-start
              [maxAvatars]="MAX_AVATAR_COUNT"
              [avatars]="customers$ | async | avatars | async"
            ></ca-avatar-stack>
            <button
              ca-action-button
              color="primary"
              (click)="openCustomerSelection()"
              >
              <mat-icon>add</mat-icon>
              {{
              (customers$ | async)
              ? (customers$
              | async
              | customerselection : ("customerDetail.title" | translate))
              : ("newMemo.selectCustomerLabel" | translate)
              }}
            </button>
          </div>
          @if (
            form.get('role').value === CARER &&
            !form.get('qualifications').get('accessAllCustomers').value &&
            customerIdsControl.hasError('required')
            ) {
            <mat-error
              >
              {{ "invite.errors.selectCustomers" | translate }}
            </mat-error>
          }
        </div>
      }
    </div>
  }

  <button ca-raised-button [disabled]="disabled" color="primary" type="submit">
    Send Invitation
  </button>
  @if (error) {
    <mat-error> Failed to send invitation. </mat-error>
  }
</form>
